import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { fetchBlogDetails } from "../services/api";
import NotFound from "../components/NotFound";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { formatUrl } from "../utils/config";

const BlogDetails = () => {
  const location = useLocation();
  const { postId } = useParams();
  const [blog, setBlog] = useState(location.state?.blogData);
  const [loading, setLoading] = useState(!location.state?.blogData);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogPost = async () => {
      if (!blog && postId) {
        try {
          setLoading(true);
          const blogData = await fetchBlogDetails(postId);
          if (blogData) {
            setBlog(blogData);
          } else {
            setError("Blog post not found");
          }
        } catch (err) {
          console.error("Error fetching blog post:", err);
          setError("Error loading blog post. Please try again later.");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchBlogPost();
  }, [postId, blog]);

  // Format the date for display
  const formattedDate = blog?.actionDate
    ? new Date(blog.actionDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "Unknown Date";

  if (loading) {
    return (
      <div className="container py-5">
        <Skeleton height={40} width={300} />
        <Skeleton height={20} count={5} />
      </div>
    );
  }

  if (error || !blog) {
    return <NotFound message={error || "No blog details available"} />;
  }

  return (
    <>
      {/* <Header /> */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/assets/img/main/m1.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Blog Details</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Blog Details</li>
            </ul>
          </div>
        </div>
      </div>

      <section className="th-blog-wrapper blog-details space-top space-extra2-bottom">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-10 col-xl-11">
              <div className="th-blog blog-single">
                <div className="blog-img">
                  <img
                    src={
                      formatUrl(blog.thumbnail) ||
                      "assets/img/blog/blog-s-1-1.jpg"
                    }
                    alt="/Blog-Image"
                    style={{ width: "100%", height: "auto" }}
                  />
                </div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <Link to="#">
                      <i className="fa-solid fa-calendar-days" />
                      {formattedDate}
                    </Link>
                  </div>
                  <h2 className="blog-title text-center">{blog.title}</h2>
                  <p
                    style={{ whiteSpace: "pre-line" }}
                    dangerouslySetInnerHTML={{ __html: blog.description }}
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Footer /> */}
    </>
  );
};

export default BlogDetails;
